<template>
  <div>
    <div class="header-pay">
      <div>
        <el-checkbox
          v-if="canOption"
          v-model="isSelect"
          style="margin-right: 12px"
        ></el-checkbox>
        <img
          src="../../../assets/pay/img-info.png"
          alt=""
          class="info-item-title"
        />
        <strong>{{ dataInfo.pricingName }}</strong>
      </div>
    </div>

    <div class="main">
      <div class="info-item">
        <div class="info-item-name">开始时间</div>
        <div class="info-item-value">
          {{ dataInfo.billStartStr }}
        </div>
      </div>
      <div class="info-item">
        <div class="info-item-name">结束时间</div>
        <div class="info-item-value">{{ dataInfo.billEndStr }}</div>
      </div>
      <div class="info-item">
        <div class="info-item-name">金额（元）</div>
        <div class="info-item-value">¥{{ dataInfo.totalAmount / 100 }}</div>
      </div>
      <div class="info-item"  v-if="!canOption">
        <div class="info-item-name">缴费时间</div>
        <div class="info-item-value">{{ dataInfo.paidTimeStr }}</div>
      </div>
      <div class="info-item"  v-if="!canOption">
        <div class="info-item-name">缴费方式</div>
        <div class="info-item-value">{{ dataInfo.payType }}</div>
      </div>
      <div class="info-item"  v-if="!canOption">
        <div class="info-item-name">备注</div>
        <div class="info-item-value">{{ dataInfo.comment }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import Utils from "../../../Utils";
export default {
  name: "InfoItem",

  props: {
    dataInfo: {},
    canOption: Boolean
  },

  watch: {
    isSelect() {
      if (this.isSelect) {
        this.$parent.selectItem(this.dataInfo.id);
      } else {
        this.$parent.deleteItem(this.dataInfo.id);
      }
    }
  },

  data() {
    return {
      isSelect: false
    };
  },

  created() {
    this.dataInfo.billStartStr = Utils.long2day(this.dataInfo.billStart * 1000);
    this.dataInfo.billEndStr = Utils.long2day(this.dataInfo.billEnd * 1000);
    this.dataInfo.paidTimeStr = Utils.long2second(this.dataInfo.paidTime * 1000);

    this.isSelect = !!this.$parent.$parent.billIdList.has(this.dataInfo.id);
  }
};
</script>

<style scoped lang="scss">
@import "page";

.header-pay {
  margin-top: 14px;
  padding: 0 14px;
  box-sizing: border-box;
  border-radius: 10px 10px 0 0;
  height: 44px;
  color: $colorDefault;
  background: white;
  display: flex;
  align-items: center;
  justify-content: space-between;
  .list-item-check {
    width: 20px;
  }
  .list-item-title {
    width: 26px;
  }
  img {
    width: 22px;
  }
  div {
    align-items: center;
    display: flex;
    * {
      margin-right: 8px;
    }
  }
}

.main {
  border-top: 1px $bgColor dotted;
  padding: 14px;
  background: white;
  box-sizing: border-box;
  border-radius: 0 0 10px 10px;
  min-height: 110px;
  .info-item {
    align-items: center;
    justify-content: space-between;
    display: flex;
    .info-item-name {
      margin-top: 5px;
      color: $fontColor-9;
    }
    .info-item-value {
      color: $fontColor-3;
    }
  }
}
</style>
